<template>
  <div>
    <ProjectsNew v-model:dialogIsOpen="dialogIsOpen" no-activator />

    <app-tile
      :label="$t('projects.project-types.ProjectTypeProject.label')"
      :caption="$t('projects.project-types.ProjectTypeProject.caption')"
      icon="folder_shared"
      icon-color="blue-500"
      icon-background-color="surface-blue-subtle"
      icon-filled
      @click="onProjectCardClicked"
    />

    <DiscoverProjectDialog v-if="discoverDialogIsOpen"
                           @close="discoverDialogIsOpen = false"
                           @createProject="createProject"
                           @requestActivation="openQuoteRequestDialog"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { QUOTE_REQUEST_TOPICS } from '@/common/utils/quoteRequestTopics'
import { SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG } from '@/store/modules/subscription/mutation_types'

import DiscoverProjectDialog from '../dialogs/DiscoverProjectDialog.vue'
import ProjectsNew from '../dialogs/ProjectsNew.vue'

export default {
  name: 'ProjectTypeProject',
  components: {
    DiscoverProjectDialog,
    ProjectsNew,
  },
  data () {
    return {
      dialogIsOpen: false,
      discoverDialogIsOpen: false,
    }
  },
  computed: {
    ...mapGetters('user', ['canCurrentUserCreateProject']),
  },
  methods: {
    ...mapMutations('subscription', [SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG]),
    createProject () {
      this.discoverDialogIsOpen = false
      this.dialogIsOpen = true
    },
    onProjectCardClicked () {
      if (this.canCurrentUserCreateProject) {
        this.dialogIsOpen = true
      } else {
        this.discoverDialogIsOpen = true
      }
    },
    openQuoteRequestDialog () {
      this.SET_PROJECT_TYPE_QUOTE_REQUEST_DIALOG({
        isOpen: true,
        defaultProjectType: QUOTE_REQUEST_TOPICS.STD_PROJECT,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .discover-label {
    color: #626262;
  }
</style>
